export enum ProjectSorting {
	SORT_BY_UPVOTES = 'total_upvotes',
	SORT_BY_DATE = '',
}
